export default __webpack_public_path__ + "static/Dinish-Regular-20b4e225aa121ac08c56f8306ee0a4e9.ttf";